import { keepPreviousData, queryOptions } from "@tanstack/react-query";

import { defaultServices } from "~/services";
import { BaseQuery } from "~/@types";
import { ExportInfo } from "~/features/export-info";

export const fetchListExportInfo = async (q: BaseQuery) => {
  const res = await defaultServices.getList<ExportInfo>({
    resource: "/export",
    query: {
      ...q,
    },
  });

  return res;
};

export const getListExportInfo = (q: BaseQuery) =>
  queryOptions({
    queryKey: ["export-info", { ...q }],
    queryFn: () => fetchListExportInfo(q),
    placeholderData: keepPreviousData,
  });
